import { render, staticRenderFns } from "./OpportunityTable.vue?vue&type=template&id=2a0c3804&scoped=true&"
import script from "./OpportunityTable.vue?vue&type=script&lang=js&"
export * from "./OpportunityTable.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OpportunityTable.vue?vue&type=style&index=1&id=2a0c3804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0c3804",
  null
  
)

export default component.exports